import { IRentsyncProperties } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import rentsyncProperties from '@/shared/services/rentsync-properties';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/syndication-api/rentsync_properties';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IRentsyncProperties>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'rentsync-properties/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,

    saveBulk(ctx: IAction<IStateStrict<IRentsyncProperties>>, payload: IRentsyncProperties[]) {
      return rentsyncProperties.saveBulk(payload);
    },
  },
};
